export default (props: {
  enableButton: CallToActionButton
  eventName: string
  hideSocialTitle?: boolean
}) => {
  const contactStore = useContactStore()
  const contact = computed(() => contactStore)

  const { t } = useI18n()
  const { getLineLink, getMessengerLink, getWhatsAppLink } = useSocialLink()

  // Define platform configurations
  const platformConfigs = computed(() => ({
    whatsapp: {
      type: 'whatsapp' as const,
      isEnabled: props.enableButton?.whatsapp && contact.value.whatsappId,
      title: t('global.chatBySocial', { title: 'WhatsApp' }),
      shortTitle: t('global.chat'),
      icon: 'fa-brands fa-whatsapp',
      link: getWhatsAppLink(contact.value.whatsappId),
      variant: 'whatsapp',
    },
    facebook: {
      type: 'facebook' as const,
      isEnabled: props.enableButton?.facebook && contact.value.facebookId,
      title: t('global.chatBySocial', { title: 'Facebook' }),
      shortTitle: t('global.chat'),
      icon: 'fa-brands fa-square-facebook',
      link: getMessengerLink(contact.value.facebookId),
      variant: 'facebook',
    },
    line: {
      type: 'line' as const,
      isEnabled: props.enableButton?.line && contact.value.lineId,
      title: t('global.chatBySocial', { title: 'Line' }),
      shortTitle: t('global.chat'),
      icon: 'fa-brands fa-line',
      link: getLineLink(contact.value.lineId),
      variant: 'line',
    },
    tel: {
      type: 'tel' as const,
      isEnabled: props.enableButton?.tel && contact.value.phoneNumbers?.length > 0,
      title: t('global.chatByTel'),
      shortTitle: t('global.chatByTel'),
      icon: 'fa-solid fa-phone',
      link: contact.value.phoneNumbers?.[0] ? `tel:${contact.value.phoneNumbers[0]}` : '',
      variant: 'primary',
    },
    custom: {
      type: 'custom' as const,
      isEnabled: props.enableButton?.callToAction && props.enableButton?.callToActionTitle && props.enableButton?.callToActionLink,
      title: props.enableButton?.callToActionTitle || '',
      icon: props.enableButton?.callToActionIcon || '',
      link: props.enableButton?.callToActionLink || '',
      variant: 'default',
    },
  } as Record<string, ProductCallToAction>))

  // Get enabled platforms
  const enabledPlatforms = computed(() =>
    Object.values(platformConfigs.value).filter(platform => platform.isEnabled),
  )

  // Calculate social count (excluding custom button)
  const socialCount = computed(() =>
    enabledPlatforms.value.filter(platform => platform.type !== 'custom').length,
  )

  const { analyticEvent, fbPixelEvent } = useAnalytic()
  const eventDetailUrlButton = (url: string) => {
    if (!url) { return }

    analyticEvent({
      ga4ActionName: props.eventName,
      ga4Label: url,
    })
    fbPixelEvent({
      fbEvent: 'Contact',
    })
  }

  return {
    platformConfigs,
    enabledPlatforms,
    socialCount,
    eventDetailUrlButton,
    getLineLink,
    getMessengerLink,
    getWhatsAppLink,
  }
}
